import { chatbotHttp as api } from "./chatbotApi";

const base = (botId) => `/bots/${encodeURIComponent(botId)}/whatsapp-notifications`;
const unwrap = (r) => r.data?.data;

export const getNotificationErrorMessage = (err, fallback = "Something went wrong.") => {
  const body = err?.response?.data;
  if (body?.message && body.message !== "ok") return body.message;
  const detail = body?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => {
      const field = Array.isArray(d?.loc) ? d.loc.filter((p) => p !== "body").join(".") : "";
      const msg = d?.msg || "Invalid value";
      return field ? `${field}: ${msg}` : msg;
    }).join("; ");
  }
  return err?.message || fallback;
};

export const listNotificationConfigs = (botId) => api.get(`${base(botId)}/configs`).then(unwrap);
export const saveNotificationConfig = (botId, eventKey, config) =>
  api.put(`${base(botId)}/configs/${encodeURIComponent(eventKey)}`, config).then(unwrap);
export const listNotifications = (botId, params) => api.get(base(botId), { params }).then(unwrap);
export const retryNotification = (botId, id) => api.post(`${base(botId)}/${id}/retry`).then(unwrap);
export const inspectNotificationTemplate = (botId, config) =>
  api.post(`${base(botId)}/templates/inspect`, config).then(unwrap);
export const previewBirthday = (botId, customerId) =>
  api.get(`${base(botId)}/birthday/preview/${encodeURIComponent(customerId)}`).then(unwrap);

export const NOTIFICATION_STATUS_LABELS = {
  pending: "Pending",
  queued: "Queued",
  processing: "Processing",
  accepted: "Accepted by WhatsApp",
  delivered: "Delivered",
  read: "Read",
  failed: "Failed",
  uncertain: "Uncertain",
  skipped: "Skipped",
};

// Only failed rows with attempts left may be retried. Uncertain rows are never retried.
// The backend also requires a stored payload and answers 409 when it is missing.
export const notificationAttemptsExhausted = (row) =>
  row?.max_attempts != null && Number(row.attempts || 0) >= Number(row.max_attempts);

// Backend can_retry also covers a missing prepared payload; older rows without it fall back to status/attempts.
export const canRetryNotification = (row) => {
  if (row?.status !== "failed") return false;
  if (typeof row.can_retry === "boolean") return row.can_retry;
  return !notificationAttemptsExhausted(row);
};

// Newest row wins when several share a resource.
export const latestNotification = (rows) =>
  [...(rows || [])].sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0) || b.id - a.id)[0] || null;
